<template>
  <edit-identifiant ref="USER_IDENTIFIANT"
                    :value=value
                    :hide-label='hideLabel'
                    :data-table='dataTable'
                    :required=required
                    :read-only=readOnly
                    :show-missing=showMissing
                    :context-id="contextId"
                    :theme=theme
                    @update:value=setUpdated
                    @status=setError>
  </edit-identifiant>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import EditBase from '@/framework/base/components/EditBase';
  import EditIdentifiant from '@/framework/base/components/EditIdentifiant.vue'
  import { RessourceGenControl, GenControl } from '@/generated/ressources/generatedRessources';

  export default defineComponent({
    extends: EditBase,
    components: {
      EditIdentifiant
    },
    computed: {
      ressource () { return RessourceGenControl(GenControl.USER_IDENTIFIANT); },
    },
    methods: {
      missing (): boolean {
        // @ts-expect-error : generated method
        return this.$refs.USER_IDENTIFIANT.missing();
      },

      touch (): void {
        // @ts-expect-error : generated method
        this.$refs.USER_IDENTIFIANT.touch();
      },

      setFocus (): void {
        // @ts-expect-error : generated method
        this.$refs.USER_IDENTIFIANT.setFocus();
      }
    }
  })
</script>
